(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yof-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.yof-faq__list[data-close-others="true"]').forEach(function (list) {
      var items = list.querySelectorAll('.yof-faq__item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) { if (other !== item && other.open) other.open = false; });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yof-hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('yof-hero-banner')) return;

    class YofHeroBanner extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-yof-hb-track]');
        this.slides = Array.from(this.querySelectorAll('[data-yof-hb-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-yof-hb-dot]'));
        this.layout = this.getAttribute('data-layout');
        this.transition = this.getAttribute('data-transition');
        this.autoplay = this.getAttribute('data-autoplay') === 'true';
        this.interval = parseInt(this.getAttribute('data-interval') || '6000', 10);
        this.index = 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.layout !== 'slider' || this.slides.length < 2) { this.playVideos(); return; }

        const prev = this.querySelector('[data-yof-hb-prev]');
        const next = this.querySelector('[data-yof-hb-next]');
        if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
        if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
        this.dots.forEach((d) => d.addEventListener('click', () => { this.go(parseInt(d.getAttribute('data-index'), 10)); this.restart(); }));

        if (this.transition === 'slide') {
          this.onScroll = this.onScroll.bind(this);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
        }

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));

        // Theme editor: jump to the selected slide, pause autoplay while editing.
        document.addEventListener('shopify:block:select', (e) => {
          const slide = e.target && e.target.closest && e.target.closest('[data-yof-hb-slide]');
          if (slide && this.contains(slide)) { this.stop(); this.go(parseInt(slide.getAttribute('data-index'), 10)); }
        });
        document.addEventListener('shopify:block:deselect', () => this.start());

        this.setActive(0);
        this.start();
      }

      disconnectedCallback() { this.stop(); }

      playVideos() {
        this.querySelectorAll('video').forEach((v) => { const p = v.play(); if (p && p.catch) p.catch(() => {}); });
      }

      go(i) {
        const n = this.slides.length;
        const idx = ((i % n) + n) % n;
        if (this.transition === 'slide') {
          const w = this.track.clientWidth;
          this.track.scrollTo({ left: idx * w, behavior: this.reduced ? 'auto' : 'smooth' });
        }
        this.setActive(idx);
      }

      setActive(idx) {
        this.index = idx;
        this.slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
        this.dots.forEach((d, i) => { d.classList.toggle('is-active', i === idx); d.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
        const v = this.slides[idx].querySelector('video');
        if (v) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
      }

      onScroll() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          const w = this.track.clientWidth || 1;
          const idx = Math.round(this.track.scrollLeft / w);
          if (idx !== this.index) this.setActive(Math.max(0, Math.min(this.slides.length - 1, idx)));
        });
      }

      start() {
        if (!this.autoplay || this.reduced || this.timer) return;
        this.timer = setInterval(() => this.go(this.index + 1), this.interval);
      }
      stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
      restart() { this.stop(); this.start(); }
    }

    customElements.define('yof-hero-banner', YofHeroBanner);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yof-insta-shop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('yof-insta-shop')) return;
    class YofInstaShop extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-yof-ig-track]');
        this.videos = Array.from(this.querySelectorAll('[data-yof-ig-video]'));
        this.prev = this.querySelector('[data-yof-ig-prev]');
        this.next = this.querySelector('[data-yof-ig-next]');
        this.autoplay = this.getAttribute('data-autoplay') !== 'false';
        this.unmuted = null;
        this.onScroll = this.onScroll.bind(this);
        this.updateArrows = this.updateArrows.bind(this);
        if (this.prev) this.prev.addEventListener('click', () => this.scrollByItem(-1));
        if (this.next) this.next.addEventListener('click', () => this.scrollByItem(1));
        if (this.track) {
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.updateArrows, { passive: true });
        }
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-yof-ig-sound]');
          if (!btn) return;
          e.preventDefault();
          this.toggleSound(btn);
        });
        this.setupAutoplay();
        this.updateArrows();
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); window.removeEventListener('resize', this.updateArrows); }
      setupAutoplay() {
        if (!this.videos.length) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.autoplay || reduced || !('IntersectionObserver' in window)) return;
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const v = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
            else { v.pause(); if (this.unmuted === v) this.muteAll(); }
          });
        }, { threshold: [0, 0.5, 1] });
        this.videos.forEach((v) => this.io.observe(v));
      }
      toggleSound(btn) {
        const item = btn.closest('.yof-ig__item');
        const v = item && item.querySelector('[data-yof-ig-video]');
        if (!v) return;
        const willUnmute = v.muted;
        this.muteAll();
        if (willUnmute) {
          v.muted = false; v.volume = 1; this.unmuted = v;
          btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Sesi kapat');
          const p = v.play(); if (p && p.catch) p.catch(() => {});
        }
      }
      muteAll() {
        this.videos.forEach((v) => { v.muted = true; });
        this.querySelectorAll('[data-yof-ig-sound]').forEach((b) => { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Sesi aç'); });
        this.unmuted = null;
      }
      itemWidth() {
        const first = this.track && this.track.querySelector('.yof-ig__item');
        if (!first) return 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      scrollByItem(dir) { if (this.track) this.track.scrollBy({ left: dir * this.itemWidth(), behavior: 'smooth' }); }
      onScroll() { if (this.raf) return; this.raf = requestAnimationFrame(() => { this.raf = null; this.updateArrows(); }); }
      updateArrows() {
        if (!this.track) return;
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.toggleAttribute('disabled', this.track.scrollLeft <= 2);
        if (this.next) this.next.toggleAttribute('disabled', this.track.scrollLeft >= max);
      }
    }
    customElements.define('yof-insta-shop', YofInstaShop);
  })();

  } catch(e) { console.error(e); }
})();
})();
